import React from 'react';
import { FaTimes } from 'react-icons/fa';

interface DeleteButtonProps {
  onDelete: () => void;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ 
  onDelete, 
  className = '', 
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-base'
  };

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (window.confirm('هل أنت متأكد من حذف هذا العنصر؟')) {
          onDelete();
        }
      }}
      className={`
        absolute top-2 right-2 
        bg-red-500 hover:bg-red-600 
        text-white rounded-full 
        flex items-center justify-center 
        transition-all duration-200 
        opacity-0 group-hover:opacity-100
        z-10 shadow-lg
        ${sizeClasses[size]}
        ${className}
      `}
      title="حذف العنصر"
    >
      <FaTimes />
    </button>
  );
};

export default DeleteButton; 